module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"captcha":"Captcha"},"zh_hk":{"captcha":"驗證碼"},"zh_cn":{"captcha":"验证码"}}')
  delete Component.options._Ctor
}
